<template>
  <v-row no-gutters justify="center">
    <v-col cols="auto">
      <div v-if="hasDeviceCalibrations">
        <label class="modal-label">Select Calibration</label>
      </div>
      <select-with-button
        v-if="hasDeviceCalibrations"
        :value="deviceCalibration"
        @input="selectCalibration"
        :items="deviceCalibrations"
        item-text="desc"
        item-value="desc"
        name="what"
        :hide-details="true"
        class="measurementControl"/>
      <div class="warning-text">{{this.warningMessage}}</div>
      <annotation-measurement-button-collection
        v-if="deviceCalibration"
        :context="context"
        @input="annotationModeButtonClick($event)"/>
    </v-col>
  </v-row>
</template>

<script>
import selectWithButton from "../../controls/SelectWithButton";
import imageAnnotationHelper from "../../mixins/ImageAnnotationHelper";
import annotationMeasurementButtonCollection from "./AnnotationMeasurementButtonCollection";
import { TEXT_SIZES } from "../../../config/config";
export default {
  name: "annotationCalibrationsCollection",
  components: { selectWithButton, annotationMeasurementButtonCollection },
  mixins: [imageAnnotationHelper],
  props: ["context"],
  data() {
    return {
      textSizes: TEXT_SIZES
    };
  },
  computed: {
    warningMessage() {
      return this.deviceCalibration
        ? ""
        : this.hasDeviceCalibrations
        ? "Please select proper calibration setting to enable measurements."
        : "";
    },
  }
}
</script>